import { useEffect, useState, useCallback, useMemo } from 'react';

import Table from '../../molecules/tablas/view';
import FacetedFilter from '../../molecules/FacetedFilter/view';

/* import ShowThird from '../../../app/thirds/organismos/showThird/view'; */

import ListIemsCompra from '../listItemsCompra/view';
import ButtonAction from '../../atoms/buttonAction/view';
import { getAllBuys, deleteBuy } from '../../../usecases/buys-usecase';
import { BiTrash } from 'react-icons/bi';
import { Zap, Calendar, User } from 'lucide-react';
import ConfirmPopUp from '../../atoms/confirmPopUp/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { EmptyArray } from '../../../app/domain/models/empty/empty';
import ShowThird from '../showThird/view';
import RadianEventsModal from '../RadianEventsModal/view';

const toISODateString = (dateVal) => {
    if (!dateVal) return '';
    const str = String(dateVal).trim();
    const isoMatch = str.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
    if (isoMatch) {
        const year = isoMatch[1];
        const month = isoMatch[2].padStart(2, '0');
        const day = isoMatch[3].padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const dmyMatch = str.match(/(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
    if (dmyMatch) {
        const day = dmyMatch[1].padStart(2, '0');
        const month = dmyMatch[2].padStart(2, '0');
        const year = dmyMatch[3];
        return `${year}-${month}-${day}`;
    }
    const d = new Date(dateVal);
    if (!isNaN(d.getTime())) {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return '';
};

const ListCompras = ({ profile }) => {
    const [loading, setLoading] = useState(false);
    const [activeFilters, setActiveFilters] = useState([]);

    const filtersConfig = [
        { key: 'date_from', label: 'Fecha Desde', icon: <Calendar size={14} />, type: 'date' },
        { key: 'date_to', label: 'Fecha Hasta', icon: <Calendar size={14} />, type: 'date' },
        { key: 'third', label: 'Tercero', icon: <User size={14} />, type: 'text' }
    ];

    const [comprasData, setComprasData] = useState({
        data: [],
        total: 0,
        page: 1,
        page_size: 10
    });
    const [radianModal, setRadianModal] = useState(null); // { xmlInvoiceData }

    const update = useCallback((page = comprasData.page, limit = comprasData.page_size) => {
        setLoading(true);
        setComprasData(prev => ({ ...prev, data: [] }));
        getAllBuys(profile.uid, profile.cid, page, limit)
            .then((res) => {
                const buysList = res?.data || [];
                const mapped = Array.isArray(buysList) ? buysList.map((item) => {
                    const formatDate = (dateStr) => {
                        if (!dateStr) return 'N/A';
                        const d = new Date(dateStr);
                        return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('es-CO');
                    };
                    const supplierName = item.tercero?.name || item.third_name || (item.third_id ? `Tercero #${item.third_id}` : 'Proveedor General');
                    const docDate = item.buy_date || item.created_at;
                    return {
                        date: formatDate(docDate),
                        document: item.documento_compra ? `#${item.bill_id} (${item.documento_compra})` : `#${item.bill_id}`,
                        tercero: {
                            third_id: item.third_id,
                            third_name: supplierName,
                            tercero: item.tercero,
                            name: supplierName
                        },
                        total: parseFloat(item.total || 0),
                        vencimiento: formatDate(item.vencimiento),
                        raw_date: docDate,
                        third_id: item.third_id,
                        bill_id: item.bill_id,
                        xml_invoice_data: item.xml_invoice_data
                    };
                }) : EmptyArray;

                setComprasData({
                    data: mapped,
                    total: res?.total || mapped.length,
                    page: res?.page || page,
                    page_size: res?.page_size || limit
                });
            })
            .catch(() => {
                dispatchCustomEvent('popup', { message: "Error al cargar compras", type: "error" });
                setComprasData(prev => ({ ...prev, data: EmptyArray }));
            })
            .finally(() => {
                setLoading(false);
            });
    }, [profile, comprasData.page, comprasData.page_size]);

    const filteredData = useMemo(() => {
        let list = comprasData.data || [];
        const dateFrom = activeFilters.find(f => f.key === 'date_from')?.value;
        const dateTo = activeFilters.find(f => f.key === 'date_to')?.value;
        const thirdVal = activeFilters.find(f => f.key === 'third')?.value;

        if (dateFrom) {
            list = list.filter(item => {
                const itemDate = toISODateString(item.raw_date);
                return itemDate ? itemDate >= dateFrom : true;
            });
        }
        if (dateTo) {
            list = list.filter(item => {
                const itemDate = toISODateString(item.raw_date);
                return itemDate ? itemDate <= dateTo : true;
            });
        }
        if (thirdVal) {
            const q = thirdVal.toLowerCase().trim();
            list = list.filter(item => {
                const tName = (item.tercero?.third_name || item.tercero?.name || item.tercero?.tercero?.name || '').toLowerCase();
                const tId = (item.tercero?.tercero?.identification || item.tercero?.identification || '').toLowerCase();
                const doc = (item.document || '').toLowerCase();
                return tName.includes(q) || tId.includes(q) || doc.includes(q);
            });
        }
        return list;
    }, [comprasData.data, activeFilters]);






    useEffect(() => {
        update();
        const cleanReload = listener('reload-list-compras', () => update());

        return () => {
            cleanReload();
        };
    }, [update]);

    const handleConfirmDelete = (data) => {
        deleteBuy(profile.uid, profile.cid, data.bill_id)
            .then(() => {
                dispatchCustomEvent('popup', { message: "Compra eliminada con éxito", type: "success" });
                update();
                dispatchCustomEvent('update-stock', {});
            })
            .catch(() => {
                dispatchCustomEvent('popup', { message: "Error al eliminar la compra", type: "error" });
            })
            .finally(() => {
                dispatchCustomEvent('loading-btn-delete-compra', { loading: false });
            });
    };

    return (
        <>
            {radianModal && (
                <RadianEventsModal
                    xmlInvoiceData={radianModal}
                    onClose={() => setRadianModal(null)}
                />
            )}
            <ConfirmPopUp
                msg='¿Estás seguro de eliminar esta compra?'
                eventKey='delete-compra'
                onAcept={handleConfirmDelete}
            />

            <Table
                id="compras-table"
                isLoading={loading}
                paginatedData={{ 
                    ...comprasData, 
                    data: filteredData,
                    total: activeFilters.length > 0 ? filteredData.length : comprasData.total 
                }}
                getFunction={update}
                allowExport={true}
                exportFileName="compras"
                toolbarActions={
                    <FacetedFilter
                        filters={filtersConfig}
                        activeFilters={activeFilters}
                        onChange={setActiveFilters}
                        onClear={() => setActiveFilters([])}
                    />
                }
                excludeList={["bill_id", "xml_invoice_data", "raw_date", "third_id"]}

                headersList={["Fecha", "Documento", "Proveedor", "Total", "Vencimiento"]}
                allowPageSizeControl={true}
                formats={{
                    tercero: {
                        type: "custom",
                        children: <ShowThird profile={profile} id="compras-lista" />
                    },
                    total: { type: "money" }
                }}
            >

                <ListIemsCompra profile={profile} />
                <ButtonAction
                    btnKey="radian-compra"
                    title={<Zap size={15} />}
                    style={{ color: '#f59e0b' }}
                    hidden={(data) => !data?.xml_invoice_data}
                    onClick={(data) => {
                        let xmlData = data?.xml_invoice_data;
                        if (typeof xmlData === 'string') {
                            try {
                                xmlData = JSON.parse(xmlData);
                            } catch (_err) {
                                // Ignorar error si el string no es JSON válido
                            }
                        }
                        if (!xmlData) {
                            dispatchCustomEvent('popup', {
                                message: 'Esta compra no cuenta con datos de factura electrónica XML para emitir eventos RADIAN.',
                                type: 'warning'
                            });
                            return;
                        }
                        setRadianModal(xmlData);
                    }}
                />
                <ButtonAction
                    btnKey="delete-compra"
                    enableLoadingAnimation={true}
                    title={<BiTrash />}
                    onClick={(data) => dispatchCustomEvent('notification-confirm-delete-compra', data)}
                />
            </Table>
        </>
    );
};

export default ListCompras
